import API from "./api";

const BatchMaterialService = {
  // Get materials for a batch with pagination and search
  getMaterials: async (
    batchId,
    parentId = null,
    page = 1,
    limit = 10,
    search = "",
  ) => {
    try {
      let url = `/batch-materials/${batchId}?page=${page}&limit=${limit}`;
      if (parentId) {
        url += `&parent_id=${parentId}`;
      }
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      const response = await API.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create new folder
  createFolder: async (batchId, folderData) => {
    try {
      const response = await API.post(
        `/batch-materials/${batchId}/folder`,
        folderData,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Upload file
  uploadFile: async (batchId, formData) => {
    try {
      const response = await API.post(`/batch-materials/${batchId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update material (folder name, title, or URL)
  updateMaterial: async (batchId, materialId, updateData) => {
    try {
      const response = await API.put(
        `/batch-materials/${batchId}/update/${materialId}`,
        updateData,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete material
  deleteMaterial: async (batchId, materialId) => {
    try {
      const response = await API.delete(
        `/batch-materials/${batchId}/delete/${materialId}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get folder path
  getFolderPath: async (batchId, materialId) => {
    try {
      const response = await API.get(
        `/batch-materials/${batchId}/path/${materialId}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get folder item count
  getFolderItemCount: async (batchId, folderId) => {
    try {
      const response = await API.get(
        `/batch-materials/${batchId}/count/${folderId}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get available batches for adopting materials
  getAvailableBatches: async (currentBatchId) => {
    try {
      const response = await API.get(
        `/batch-materials/available-batches/${currentBatchId}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get all materials for a batch (for adoption modal)
  getAllMaterialsForBatch: async (batchId) => {
    try {
      const response = await API.get(`/batch-materials/all/${batchId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Adopt materials from source batch to target batch
  adoptMaterials: async (sourceBatchId, targetBatchId, materialIds) => {
    try {
      const response = await API.post("/batch-materials/adopt", {
        source_batch_id: sourceBatchId,
        target_batch_id: targetBatchId,
        material_ids: materialIds,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  // Move material up
  moveUp: async (batchId, materialId) => {
    try {
      const response = await API.post(
        `/batch-materials/${batchId}/move-up/${materialId}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Move material down
  moveDown: async (batchId, materialId) => {
    try {
      const response = await API.post(
        `/batch-materials/${batchId}/move-down/${materialId}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default BatchMaterialService;
